// function to validate first name
export const validateFirstName = (firstName: string) => {
    // check if first name contains only letters (any unicode characters)
    if (!/^[\p{L}\p{M}\s]+$/u.test(firstName)) {
        return 'first-name-invalid';
    }
    return '';
};

// function to validate last name
export const validateLastName = (lastName: string) => {
    // check if first name contains only letters (any unicode characters)
    if (!/^[\p{L}\p{M}\s]+$/u.test(lastName)) {
        return 'last-name-invalid';
    }
    return '';
};

// function to validate email
export const validateEmail = (email: string) => {
    // check if email is valid (any unicode characters)
    if (!/^[\p{L}\p{N}\p{M}\p{P}\p{S}]+@([\p{L}\p{N}\p{M}\p{P}\p{S}]+\.)+[\p{L}\p{M}]{2,}$/u.test(email)) {
        return 'email-invalid';
    }
    return '';
};

// function to validate street
export const validateStreet = (/* street: string, :  */) => {
    return '';
};

// function to validate city
export const validateCity = (/* city: string, :  */) => {
    return '';
};

// function to validate postal code
export const validatePostalCode = (postalCode: string) => {
    // check if postal code is valid using regex
    if (!/^[a-zA-Z0-9 ]{3,10}$/.test(postalCode)) {
        return 'zip-code-invalid';
    }
    return '';
};

// function to validate country
export const validateCountry = (/* country: string, :  */) => {
    return '';
};

// function to validate phone
export const validatePhone = (phone: string) => {
    // check if phone number is valid using regex
    if (!/^[0-9+]+$/.test(phone)) {
        return  'phone-invalid';
    }
    return '';
};

// function to validate mobile
export const validateMobile = (phone: string) => {
    // check if phone number is valid using regex
    if (!/^[0-9+]+$/.test(phone)) {
        return 'phone-invalid';
    }
    return '';
};

type ValidationResponse = {
    valid: boolean;
    errorMessage: string;
};
export const validate = (
    key: string,
    value: string,
): ValidationResponse => {
    let valid = false;
    let errorMessage = '';

    switch (key) {
        case 'firstname': {
            const error = validateFirstName(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'lastname': {
            const error = validateLastName(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'email': {
            const error = validateEmail(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'country': {
            const error = validateCountry(/* value,  */);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'zip': {
            const error = validatePostalCode(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'street': {
            const error = validateStreet(/* value,  */);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'city': {
            const error = validateCity(/* value,  */);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'phone': {
            const error = validatePhone(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        } case 'mobile': {
            const error = validateMobile(value);
            if(error) {
                valid = false;
                errorMessage = error;
            } else {
                valid = true;
            }
            break;
        }
        
        default:
            valid = true;
    }
    return {
        valid,
        errorMessage
    };
};
